<template>
    <v-app-bar scroll-behavior="hide" height="68">

        <v-app-bar-nav-icon variant="text" @click="$emit('toggle-drawer')"
            v-if="menu && menu.length > 0"></v-app-bar-nav-icon>
        <span v-else class="ml-2 mr-2"></span>
        <!-- Logo / nome -->
        <div class="app-title d-flex align-center" @click="naviga({ link: '/' })" style="cursor: pointer;">
            <v-img :src="require('@/assets/logo.svg')" width="34" height="34" class="mr-3 flex-grow-0" />
            <div>
                <div class="font-weight-bold" style="font-size: 1.05em; line-height: 1.15;">Planner</div>
                <div class="text-caption text-medium-emphasis" style="line-height: 1;">Manutenzioni · Mezzi · Amministrazione</div>
            </div>
        </div>

        <v-spacer />

        <!-- Notifiche: badge visibile solo se ci sono notifiche non lette -->
        <v-btn icon @click="apriNotifiche" class="mr-1">
            <v-badge :model-value="nonLette > 0" :content="nonLette" color="error" overlap>
                <v-icon size="x-large">mdi-bell-outline</v-icon>
            </v-badge>
        </v-btn>

        <!-- Menu utente -->
        <v-menu transition="slide-y-transition">

            <template #activator="{ props }">
                <v-btn icon v-bind="props">
                    <v-icon size="x-large">mdi-account-circle</v-icon>
                </v-btn>
            </template>

            <v-card min-width="220">
                <v-list>
                    <v-list-item>
                        <template #prepend>
                            <v-icon size="x-large">mdi-account-circle</v-icon>
                        </template>
                        <v-list-item-title>
                            {{ utente }}
                        </v-list-item-title>
                        <v-list-item-subtitle>
                            {{ mail }}
                        </v-list-item-subtitle>
                    </v-list-item>
                </v-list>

                <v-divider />

                <v-list density="compact">

                    <v-list-item prepend-icon="mdi-account-cog" @click="profilo()">
                        <v-list-item-title>
                            Profilo
                        </v-list-item-title>
                    </v-list-item>

                    <v-list-item prepend-icon="mdi-logout" @click="esci()">
                        <v-list-item-title>
                            Esci
                        </v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-card>
        </v-menu>
    </v-app-bar>
</template>

<script>
export default {
    name: "ToolBarComponent",
    props: {
        utente: { type: String, default: "" },
        mail: { type: String, default: "" },
        menu: { type: Array, default: () => [] },
    },
    emits: ["esci", "toggle-drawer"],

    data() {
        return {
            disabilitaBtn: false,
        };
    },

    computed: {
        nonLette() {
            return this.$store.getters["notifiche/nonLette"];
        },
    },

    methods: {
        esci() {
            this.disabilitaBtn = true;
            this.$emit("esci");
        },

        profilo() {
            this.$router.push({ path: "/profilo" });
        },

        apriNotifiche() {
            this.$router.push({ path: "/notifiche" });
        },

        naviga(item) {
            this.disabilitaBtn = true;
            if (item.link.startsWith("/")) {
                this.$router.push({ path: item.link });
            } else if (item.link == "@esci") {
                this.$emit("esci");
            }
            this.disabilitaBtn = false;
        },

        isActive(link) {
            return this.$route.path === link || this.$route.path.startsWith(link + "/");
        },
    },
};
</script>